<template>
    <v-container fluid class="py-0 my-0">
        <v-row justify="center" class=" py-0 my-0">
            <v-col cols="8" class="py-0 my-0">
                <v-alert
                        border="bottom"
                        text
                        color="primary"
                        elevation="2">
                    <div v-if="selectedStudent ==null">
                        <v-row justify="space-between">
                            <v-col class="py-0 caption text-center text--primary" cols="6">
                                <v-autocomplete :items="academicItems" v-model="selectedAcademicId" item-value="id" item-text="department" outlined dense label="Τμήμα"/>
                            </v-col>

                            <v-col class="py-0 caption text-center text--primary" cols="6">
                                <v-text-field v-model="selectedAm"  dense outlined label="Αριθμός Μητρώου"/>
                            </v-col>
                        </v-row>

                        <v-row justify="center" class="pa-0 ma-0">
                        <v-col cols="4" class="pa-0 ma-0">
                            <v-btn
                                   @click="searchStudent()"
                                   color="primary">Αναζήτηση
                                <v-icon color="white">search</v-icon>
                            </v-btn>
                        </v-col>

                    </v-row>
                    </div>
                    <div v-else>
                        <v-row justify="space-between">
                            <v-col cols="1">
                                <v-tooltip  top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" fab @click="selectedStudent=null" small color="primary"><v-icon color="white">search</v-icon></v-btn>
                                    </template>
                                    <span >Επιστροφή στην αναζήτηση</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="5">

                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title>Ονοματεπώνυμο</v-list-item-title>
                                        <v-list-item-subtitle>{{selectedStudent.firstname}} {{selectedStudent.lastname}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>


                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title>Πατρώνυμο</v-list-item-title>
                                        <v-list-item-subtitle>{{selectedStudent.fathername}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>


                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title>Ίδρυμα</v-list-item-title>
                                        <v-list-item-subtitle>{{selectedStudent.institution}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>

                            <v-col cols="6">

                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title>Σχολή</v-list-item-title>
                                        <v-list-item-subtitle>{{selectedStudent.school}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>


                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title>Τμήμα</v-list-item-title>
                                        <v-list-item-subtitle>{{selectedStudent.department}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>


                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title>Αριθμός Μητρώου</v-list-item-title>
                                        <v-list-item-subtitle>{{selectedStudent.am}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>

                        </v-row>
                        <v-row justify="center" v-if="!selectedStudent.active">
                            <v-alert
                                    color="red" dense
                                    icon="mdi-account-alert"
                                    outlined text> Απενεργοποιημένος Λογαριασμός
                            </v-alert>
                        </v-row>
                    </div>
                </v-alert>
            </v-col>
        </v-row>

        <v-row >
            <v-col lg="4" md="4" sm="12">
                <v-text-field class="mb-2"
                              v-model="search2" dense
                              append-icon="search"
                              label="Αναζήτηση" placeholder="για τα πεδία (κωδικός, τίτλος, isbn, έτος)"
                              single-line
                              hide-details/>
            </v-col>
            <v-col lg="4" md="4" sm="12">
                <h4>Συγγράμματα που οφείλει να επιστρέψει ο φοιτητής</h4>
            </v-col>
        </v-row>
        <v-divider/>

        <v-row >
            <v-col cols="12">
                <v-data-table
                    no-data-text="Ο φοιτητής δεν οφείλει να επιστρέψει κάποιο σύγγραμμα"
                    :headers="headers1" :search="search2"
                    :items="mandatoryBooksForReturn"
                    :footer-props="{
                        itemsPerPageOptions:[5,15,25,-1],
                        'items-per-page-text':'Ανά γραμμή',
                        'items-per-page-all-text': 'Όλα',
                        prevIcon: 'mdi-arrow-left-bold',
                        nextIcon: 'mdi-arrow-right-bold'
                    }"
                    :items-per-page="15">
                    <template v-slot:item="{ item }">
                        <tr >
                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                <v-tooltip  left>
                                    <template v-slot:activator="{ on }">
                                        <v-icon class="pb-1" v-on="on" color="red">mdi-alert-outline</v-icon>
                                    </template>
                                    <span >Παραδομένο Εσφαλμένα</span>
                                </v-tooltip>
                            </td>
                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                {{item.book.id}}
                            </td>

                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                {{item.book.title}} <v-icon small @click="showBookInfo(item.book)" color="secondary"> search</v-icon>
                            </td>

                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                {{item.book.isbn}}
                            </td>
                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                {{returnPeriodText(item.statementPeriod)}}
                            </td>
                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                {{item.statementYear}}
                            </td>
                            <td style="height: 40px;color:red" class="text-center d-sm-table-cell d-flex">
                                {{returnStatusText(item)}}
                            </td>
                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                <v-btn @click="returnToLibrary(item, true)" v-if="item.status === 'DELIVERED'"  small outlined rounded color="secondary"> Επιστροφή στη βιβλιοθήκη </v-btn>
                                <v-btn @click="cancelReturnToLibrary(item, true)" v-else  small outlined rounded color="indianRed"> Ακύρωση Επιστροφής </v-btn>
                            </td>
                        <tr/>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-row >
            <v-col >
                <v-row justify="start">
                    <v-col lg="4" md="4" sm="12">
                        <v-text-field class="mb-2"
                                v-model="search1" dense
                                append-icon="search"
                                label="Αναζήτηση"
                                placeholder="για τα πεδία (κωδικός, τίτλος, isbn, έτος)"
                                single-line
                                hide-details/>
                    </v-col>
                    <v-col lg="4" md="4" sm="12">
                        <h4>Συγγράμματα του φοιτητή για εθελοντική επιστροφή</h4>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-divider/>

        <v-row >
            <v-col cols="12">
                <v-data-table
                        no-data-text="Ο φοιτητής δεν οφείλει να επιστρέψει κάποιο σύγγραμμα"
                        :headers="headers" :search="search1"
                        :items="booksForReturn"
                        :footer-props="{
                            itemsPerPageOptions:[5,15,25,-1],
                            'items-per-page-text':'Ανά γραμμή',
                            'items-per-page-all-text': 'Όλα',
                            prevIcon: 'mdi-arrow-left-bold',
                            nextIcon: 'mdi-arrow-right-bold'
                        }"
                        :items-per-page="15">
                    <template v-slot:item="{ item }">
                        <tr >
                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                {{item.book.id}}
                            </td>

                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                {{item.book.title}} <v-icon small @click="showBookInfo(item.book)" color="secondary"> search</v-icon>
                            </td>

                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                {{item.book.isbn}}
                            </td>
                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                {{returnPeriodText(item.statementPeriod)}}
                            </td>
                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                {{item.statementYear}}
                            </td>
                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                {{returnStatusText(item)}}
                            </td>
                            <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                <v-btn @click="returnToLibrary(item, false)" v-if="item.status === 'DELIVERED'"  small outlined rounded color="secondary"> Επιστροφή στη βιβλιοθήκη </v-btn>
                                <v-btn @click="cancelReturnToLibrary(item, false)" v-else  small outlined rounded color="indianRed"> Ακύρωση Επιστροφής </v-btn>
                            </td>
                        <tr/>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <ConfirmDialogue ref="confirmDialog"/>
        <BookInfoDialog :book="bookForInfoDialog"/>
    </v-container>
</template>

<script>
	import requests from "../requests";
	import ConfirmDialogue from "./ConfirmDialog";
	import BookInfoDialog from "./BookInfoDialog";

	export default {
		name: "Search",
		components: {BookInfoDialog, ConfirmDialogue},
		data:()=> ({
	        headers1: [
                { text: '', value: '', align: 'center', sortable: false, width: '2%'},
                { text: 'Kωδικός Βιβλίου', value: 'book.id', align: 'center', sortable: true, width: '10%'},
                { text: 'Βιβλίο', value: 'book.title', align: 'center', sortable: true, width: '30%'},
                { text: 'ISBN', value: 'book.isbn', align: 'center', sortable: true, width: '7%'},
                { text: 'Περίοδος', value: 'statementPeriod', align: 'center', sortable: true, width: '7%'},
                { text: 'Έτος', value: 'statementYear', align: 'center',sortable: true, width: '6%'},
                { text: 'Κατάσταση', align: 'center', sortable: false, width: '25%'},
                { text: 'Ενέργειες', align: 'center', sortable: false, width: '13%'},
            ],
            headers: [
                { text: 'Kωδικός Βιβλίου', value: 'book.id', align: 'center', sortable: true, width: '10%'},
                { text: 'Βιβλίο', value: 'book.title', align: 'center', sortable: true, width: '30%'},
                { text: 'ISBN', value: 'book.isbn', align: 'center', sortable: true, width: '7%'},
                { text: 'Περίοδος', value: 'statementPeriod', align: 'center', sortable: true, width: '7%'},
                { text: 'Έτος', value: 'statementYear', align: 'center',sortable: true, width: '6%'},
                { text: 'Κατάσταση', align: 'center', sortable: false, width: '25%'},
                { text: 'Ενέργειες', align: 'center', sortable: false, width: '15%'},
            ],
            search1:'',
            search2:'',
			bookForInfoDialog:{},
	        selectedAcademicId:'',
	        selectedAm:'',
	        selectedStudent:null,
	        academicItems:[],
            asyncResponses:0,
            booksForReturn:[],
            mandatoryBooksForReturn:[],


        }),

        methods:{

	        showBookInfo(book){
		        document.activeElement.blur();
	        	this.bookForInfoDialog = book;
		        this.$store.commit('setBookInfoDialog', true);
            },

	        async returnToLibrary(item, mandatory){
                document.activeElement.blur();
				const ok = await this.$refs.confirmDialog.show({
					message: 'Είστε σίγουρος/η ότι θέλετε να επιστραφεί το βιβλίο στην βιβλιοθήκη;'
				});

				if(ok){
					this.$store.commit('setLoadingModal', true);
					requests.post('rest/search/return-book-to-library', item.id, () =>{
						if(mandatory){
							requests.get('rest/search/mandatory-book-returns/' + this.selectedStudent.id , this.mandatoryBookReturnsCallBack);
						}else{
							requests.get('rest/search/books-returns/' + this.selectedStudent.id , this.bookReturnsCallBack);
						}

				    });
                }
            },

	        async cancelReturnToLibrary(item, mandatory){
                document.activeElement.blur();
				const ok = await this.$refs.confirmDialog.show({
					message: 'Είστε σίγουρος/η ότι θέλετε να ακυρώσετε την επιστροφή;'
				});

				if(ok){
					this.$store.commit('setLoadingModal', true);
                    requests.post('rest/search/cancel-book-return', item.id, () =>{
	                    if(mandatory){
		                    requests.get('rest/search/mandatory-book-returns/' + this.selectedStudent.id , this.mandatoryBookReturnsCallBack);
	                    }else{
		                    requests.get('rest/search/books-returns/' + this.selectedStudent.id , this.bookReturnsCallBack);
	                    }
                    });

                }
            },


			returnPeriodText(period){
                if(period == null){
                	return '--';
                }else if(period === 'Earino'){
	                return 'Εαρινό';
                }else if(period === 'Ximerino'){
	                return 'Χειμερινό';
                }else{
	                return 'Ετήσιο';
                }
            },

	        returnStatusText(item){
				if(item.status === 'DELIVERED'){
					return 'Παραδομένο στον φοιτητή \n Κωδικός παράδοσης: ' + item.id + ' - ' + item.deliveredDateString;
                }else{
					return 'Το βιβλίο επιστράφηκε στη βιβλιοθήκη';
                }
            },

			searchStudent(){
				this.$store.commit('setLoadingModal', true);
				let requestObj = {
					academicId:this.selectedAcademicId,
                    am:this.selectedAm
                };
				requests.put('rest/search/student', requestObj, (resp) =>{
					this.selectedStudent = JSON.parse(JSON.stringify(resp));
					requests.get('rest/search/books-returns/' + resp.id , this.bookReturnsAsyncCallBack);
					requests.get('rest/search/mandatory-book-returns/' + resp.id , this.mandatoryBookReturnsAsyncCallBack);
				})
            },

	        bookReturnsAsyncCallBack(resp){
				this.booksForReturn = JSON.parse(JSON.stringify(resp));
				this.asyncResponses++;
            },

	        mandatoryBookReturnsAsyncCallBack(resp){
		        this.mandatoryBooksForReturn = JSON.parse(JSON.stringify(resp));
		        this.asyncResponses++;
            },

	        bookReturnsCallBack(resp){
				this.booksForReturn = JSON.parse(JSON.stringify(resp));
		        this.$store.commit('setLoadingModal', false);
            },

	        mandatoryBookReturnsCallBack(resp){
		        this.mandatoryBooksForReturn = JSON.parse(JSON.stringify(resp));
		        this.$store.commit('setLoadingModal', false);
            },

        },

        created() {
	        this.$store.commit('setLoadingModal', true);
			requests.get('rest/search/academics/' + this.$store.getters.homePageInformation.institutionId, (resp) =>{
				this.academicItems = JSON.parse(JSON.stringify(resp));
                this.$store.commit('setLoadingModal', false);
            })
        },

		watch:{
			'asyncResponses': function(val) {
				if(val ===2){
					this.$store.commit('setLoadingModal', false);
					this.asyncResponses = 0;
                }
			}
		},
	}
</script>

<style scoped>
    .compact-form {
        transform: scale(0.775);
    }
</style>